import 'styles/Modal.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import * as actions from 'actions'
import ImageViewer from 'components/Gallery/ImageViewer'

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      content: null
    }

    this.closeModal = this.closeModal.bind(this)
  }

  closeModal() {
    document.body.classList.remove('toggle--overflow')
    this.props.dispatch(actions.token.toggleModal({
      modalIsOpen: false,
      modalContent: null
    }))
  }

  componentWillReceiveProps(nextProps) {
    console.log('will receive props')
    this.setState({
      modalIsOpen: nextProps.modalIsOpen,
      content: nextProps.content
    })
  }

  componentDidMount() {
    if (this.state.modalIsOpen && this.state.content)
      document.body.classList.add('toggle--overflow')
    else
      document.body.classList.remove('toggle--overflow')
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.modalIsOpen && this.state.content)
      document.body.classList.add('toggle--overflow')
    else
      document.body.classList.remove('toggle--overflow')
  }

  render() {
    if (this.state.modalIsOpen && this.state.content) {
      return (
        <div className='modal'>
          <span className='close-btn' onClick={this.closeModal} >+</span>
          <div className='modal-content'>
            <ImageViewer photo={this.state.content}/>
          </div>
        </div>
      )
    } else {
      return (null)
    }
  }
}

Modal.contextTypes = {
}
Modal.propTypes = {
  content: React.PropTypes.object //.isRequired
}
function mapStateToProps(state, ownProps) {
  if (!state.token.modalState) {
    return {
      modalIsOpen: false,
      content: null
    }
  }
  return {
    modalIsOpen: state.token.modalState.modalIsOpen,
    content: state.token.modalState.modalContent
  }
}

export default connect(mapStateToProps)(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal.js